import { Injectable } from '@angular/core';
import { TicketsSupportStatusesEndpoint } from '@fullyops/legacy/data';

@Injectable({
  providedIn: 'root',
})
export class UiTicketsSupportStatusesService {
  readonly statuses$ = this.statuses.createStore();

  constructor(protected statuses: TicketsSupportStatusesEndpoint) {}

  loadAll() {
    this.loadStatuses();
  }

  loadStatuses() {
    this.statuses
      .getAll(undefined, this.statuses$)
      .subscribe({ error: console.error });
  }
}
